import React from "react"
import PricingPanel from "./components/PricingPanel"

class Pricing extends React.Component {
  render() {
    return (
      <PricingPanel
        configuratorUrl={this.props.configurator_url}
        i18n={I18n[this.props.locale]}
        locale={this.props.locale}
        pricings={this.props.pricings}
        currencyTags={this.props.currency_tags}
        selectArrowIcon={this.props.select_arrow_icon}
      />
    )
  }
}

const I18n = {
  pl: {
    locale: "pl",
    color_variant: "Wariant kolorystyczny",
    handles_price: "Uchwyty",
    sum: "suma",
    or: "lub",
    collection: "Kolekcja",
    model: "Model",
    select_front_kind: "Wybierz wykończenie",
    select_front_model: "Wybierz model",
    price_your_kitchen: "Wyceń swój projekt",
    sample_front_pricings: `Porównaj ceny wybranego układu kuchni lub szafy dla różnych modeli \ni kolorów naszych frontów`,
    routes: {
      collections: "kolekcje",
      fronts: "produkty/fronty",
    },
  },
  en: {
    locale: "en",
    color_variant: "Colour option",
    handles_price: "Handles",
    sum: "sum",
    or: "or",
    collection: "Collection",
    model: "Model",
    select_front_kind: "Select finish",
    select_front_model: "Select model ",
    price_your_kitchen: "Quote your project",
    sample_front_pricings:
      "Compare prices of kitchen and wardrobe configurations for different models and colors of our fronts",
    routes: {
      collections: "collections",
      fronts: "products/fronts",
    },
  },
  de: {
    locale: "de",
    color_variant: "Color variant",
    handles_price: "Griffe",
    sum: "Gesamt",
    or: "oder",
    collection: "Kollektion",
    model: "Modell",
    select_front_kind: "Wählen Sie die Ausführung",
    select_front_model: "Modell wählen",
    price_your_kitchen: "Jetzt berechnen",
    sample_front_pricings:
      "Vergleichen Sie die Preise eines ausgewählten Küchenlayouts oder Schranks für verschiedene Modelle und Farben unserer Fronten.",
    routes: {
      collections: "Kollektionen",
      fronts: "Produkte/Fronten",
    },
  },
  fr: {
    locale: "fr",
    color_variant: "Variante de couleur",
    handles_price: "Poignées",
    sum: "somme",
    or: "ou",
    collection: "Collection",
    model: "Modèle",
    select_front_kind: "Sélectionnez la finition",
    select_front_model: "Sélectionnez le modèle",
    price_your_kitchen: "Obtenir un devis",
    sample_front_pricings:
      "Comparez les prix de la configuration de cuisine ou d'armoire sélectionnée pour différents modèles et couleurs de nos façades",
    routes: {
      collections: "collections",
      fronts: "produits/facades",
    },
  },
}

export default Pricing
